import {
  MoreVert,
  PowerSettingsNew,
  Menu as MenuIcon,
  Assignment,
  AssignmentInd,
  Domain,
  ContentPasteSearch,
  ScreenSearchDesktop as ScreenSearchDesktopIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
} from '@mui/icons-material';
import {
  AppBar as MuiAppBar,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import Logo from 'assets/png/logo.png';
import { useApp, useAuth } from 'contexts';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ShowMenuItem,
  HideMenuItem,
  UserName,
  DrawerContainer,
  LogoWrapper,
  FlexRow,
  PopupRight,
} from './styles';
import { ManagementStatus, TypeUser } from 'types/enums';

const menuItems = [
  {
    id: 'dossiers',
    label: 'Dossiês',
    icon: <ContentPasteSearch />,
    path: '/search',
    placement: 'top',
    allowed: (user: any) => true,
  },
  {
    id: 'models',
    label: 'Modelos',
    icon: <Assignment />,
    path: '/models',
    placement: 'top',
    allowed: (user: any) =>
      user?.typeUser !== TypeUser.COLLABORATOR ||
      user.managementStatus?.includes(ManagementStatus.MODEL),
  },
  {
    id: 'users',
    label: 'Usuários',
    icon: <AssignmentInd />,
    path: '/users',
    placement: 'top',
    allowed: (user: any) =>
      user?.typeUser !== TypeUser.COLLABORATOR ||
      user.managementStatus?.includes(ManagementStatus.USER),
  },
  {
    id: 'risks',
    label: 'Matriz de Risco',
    icon: <AssignmentInd />,
    path: '/risks',
    placement: 'top',
    allowed: (user: any) =>
      user?.typeUser !== TypeUser.COLLABORATOR ||
      user.managementStatus?.includes(ManagementStatus.PODEN),
  },
  {
    id: 'companies',
    label: 'Empresas',
    icon: <Domain />,
    path: '/companies',
    placement: 'top',
    allowed: (user: any) => user?.typeUser === TypeUser.ADM,
  },
  {
    id: 'logsUser',
    label: 'Fontes Consultadas',
    icon: <AssignmentInd />,
    path: '/logsUser',
    placement: 'popup',
    allowed: (user: any) =>
      user?.typeUser === TypeUser.ADM ||
      user?.typeUser === TypeUser.USER,
  },
  {
    id: 'controlPanel',
    label: 'Painel de Controle',
    icon: <ScreenSearchDesktopIcon />,
    path: '/controlPanel',
    placement: 'popup',
    allowed: (user: any) => user?.typeUser === TypeUser.ADM,
  },
  {
    id: 'commercialPlans',
    label: 'Planos Comerciais',
    icon: <AccountBalanceWalletIcon />,
    path: '/commercialPlans',
    placement: 'popup',
    allowed: (user: any) => user?.typeUser === TypeUser.ADM,
  },
  {
    id: 'financialHistory',
    label: 'Histórico Financeiro',
    icon: <AccountBalanceWalletIcon />,
    path: '/balance',
    placement: 'popup',
    allowed: (user: any) =>
      user?.typeUser === TypeUser.ADM ||
      user?.typeUser === TypeUser.USER,
  },
];

function AppBar() {
  const { user } = useAuth();
  const { isExitConfirm, setIsExitConfirm } = useApp();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const toggleDrawer = () => setOpen(!open);

  const [anchorElUser, setAnchorElUser] =
    useState<null | HTMLElement>(null);
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  const handleNavigate = (path: string) => {
    if (
      !isExitConfirm ||
      window.confirm('Há informações não salvas, deseja mesmo sair?')
    ) {
      navigate(path);
      setIsExitConfirm(false);
    }
  };

  return (
    <MuiAppBar position="fixed" color="default">
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <ShowMenuItem>
            <IconButton onClick={toggleDrawer}>
              <MenuIcon color="primary" />
            </IconButton>
          </ShowMenuItem>

          <Drawer anchor="left" open={open} onClose={toggleDrawer}>
            <DrawerContainer>
              <List>
                {menuItems
                  .filter(
                    (item) =>
                      item.placement === 'top' && item.allowed(user)
                  )
                  .map((item) => (
                    <Button
                      key={item.id}
                      fullWidth
                      style={{
                        textTransform: 'none',
                        justifyContent: 'left',
                        alignItems: 'center',
                        padding: '0.5rem 1rem',
                      }}
                      onClick={() => {
                        toggleDrawer();
                        handleNavigate(item.path);
                      }}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <Typography
                        component="p"
                        variant="h5"
                        color="primary"
                      >
                        {item.label}
                      </Typography>
                    </Button>
                  ))}

                <Button
                  fullWidth
                  style={{
                    textTransform: 'none',
                    justifyContent: 'left',
                    alignItems: 'center',
                    padding: '0.5rem 1rem',
                  }}
                  onClick={() => {
                    handleNavigate('/');
                    signOut();
                  }}
                >
                  <ListItemIcon>
                    <PowerSettingsNew />
                  </ListItemIcon>
                  <Typography
                    component="p"
                    variant="h5"
                    color="primary"
                  >
                    Sair
                  </Typography>
                </Button>
              </List>
            </DrawerContainer>
          </Drawer>

          <LogoWrapper onClick={() => handleNavigate('/search')}>
            <img src={Logo} alt="logo legal audit" width="200rem" />
          </LogoWrapper>

          <HideMenuItem>
            <FlexRow>
              {menuItems
                .filter(
                  (item) =>
                    item.placement !== 'popup' && item.allowed(user)
                )
                .map((item) => (
                  <Typography
                    key={item.id}
                    component="p"
                    variant="h5"
                    color="primary"
                    onClick={() => handleNavigate(item.path)}
                    sx={{ cursor: 'pointer' }}
                  >
                    {item.label}
                  </Typography>
                ))}
            </FlexRow>
          </HideMenuItem>

          <PopupRight>
            <IconButton onClick={handleOpenUserMenu}>
              <MoreVert color="primary" />
            </IconButton>

            <HideMenuItem>
              <Menu
                disableScrollLock
                sx={{ mt: '45px' }}
                id="menuAppbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <UserName>
                  <p>Olá, {user.name}</p>
                </UserName>
                {menuItems
                  .filter(
                    (item) =>
                      item.placement !== 'top' && item.allowed(user)
                  )
                  .map((item) => (
                    <MenuItem
                      key={item.id}
                      onClick={() => {
                        handleCloseUserMenu();
                        handleNavigate(item.path);
                      }}
                      sx={{
                        transition: 'all 0.5s ease',
                        ':hover svg': {
                          transition: 'all 0.5s ease',
                        },
                      }}
                    >
                      <ListItemIcon
                        style={{ color: theme.palette.primary.light }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <Typography textAlign="center">
                        {item.label}
                      </Typography>
                    </MenuItem>
                  ))}

                <MenuItem
                  style={{
                    textTransform: 'none',
                    justifyContent: 'left',
                    alignItems: 'center',
                    padding: '0.5rem 1rem',
                  }}
                  onClick={() => {
                    handleNavigate('/');
                    signOut();
                  }}
                >
                  <ListItemIcon
                    style={{ color: theme.palette.error.main }}
                  >
                    <PowerSettingsNew />
                  </ListItemIcon>
                  <Typography style={{ minWidth: '7rem' }}>
                    Sair
                  </Typography>
                </MenuItem>
              </Menu>
            </HideMenuItem>
          </PopupRight>
        </Toolbar>
      </Container>
    </MuiAppBar>
  );
}

export default AppBar;
